// extracted by mini-css-extract-plugin
export default {"root":"_301kH","traded":"_2foBU","icon":"PEoTr","warning":"_326iA"};